// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__egrQe","badges":"styles_badges__1PRGv"};